<script>
export default {
    props: ['data'],
    name: "logos",
    data() {
        return {};
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="logos">
        <div class="title">无忧知选</div>
        <div class="layout_main list">
            <template v-for="(item, index) in data">
                <a class="item" v-if="item.link" :href="item.link" target="_blank">
                    <img :src="item.logo" alt=""/>
                </a>
                <div class="item" v-else>
                    <img :src="item.logo" alt=""/>
                </div>
            </template>
        </div>
    </div>
</template>

<style scoped lang="scss">
.logos{
    padding: 0 0 1rem;
    .title{
        font-size: .4rem;
        text-align: center;
        margin-bottom: .7rem;
    }
    .list{
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: .5rem;
        .item{
            img{
                height: .75rem;
            }
        }
    }
    @media only screen and (max-width: 750px) {
        padding-bottom: .7rem;
        .title{
            font-size: .36rem;
            margin-bottom: .4rem;
        }
        .list{
            .item{
                img{
                    height: .5rem;
                }
            }
        }
    }
}
</style>